
import * as Query from "../static data/queryparams";

import * as Constants from "../config";
import * as selectvalues from "../static data/selectvalues";
import * as wishlistService from "../tools/wishlist-service";
import { useEffect, useRef, useState } from "react";
import Header from "../components/header";
import LeftMenu from "../components/left-menu";
import ApartCard from "../components/apart-card";
import { BrowserView, MobileView, isMobile } from "react-device-detect";
import ContactUs from "../components/contact-us";
import { numberWithCommas } from "../tools/valueshelper";

import Map from 'react-map-gl/maplibre';
import { NavigationControl } from 'react-map-gl/maplibre';
import maplibregl from 'maplibre-gl';
import * as turf from '@turf/turf';

import * as Keys from "../static data/keys"; 
import 'maplibre-gl/dist/maplibre-gl.css'
import { useTranslation } from "react-i18next";
import { useSwipeable } from "react-swipeable";


const MAP_STYLE = `https://api.maptiler.com/maps/streets/style.json?key=${Keys.MAPTILER_KEY}`;


export default function Details(){
    const { t, i18n } = useTranslation();
    const [apartid, setApartId] = useState(getUrlParams);  
    const [apartment, setApartment] = useState({});
    const [allAparts, setAllAparts] = useState();
    const [enlargeimg, setenlargeimg] = useState();
    const [modalOpened,setModalOpened] = useState(false);
    const CIRCLE_RADIUS_METERS = 140;
    const mapRef = useRef(null);
    const [stateChange,setSateChange] = useState(false);

    function getStatusClass(status){
        if(selectvalues.SoldStatus == status)
            return "Sold";
        if(selectvalues.Reservedtatus == status)
            return "Reserved";        
        if(selectvalues.Promotiontatus == status)
            return "Promotion";
    }

    function getUrlParams(){
        var id;
        let search = window.location.search;
        let params = new URLSearchParams(search);
        id = params.get(Query.id);
        return id;
    }

    function getData() {
        var id;
        let search = window.location.search;
        let params = new URLSearchParams(search);
        id = params.get(Query.id);
        fetch(Constants.apiurl + Constants.apartments, Constants.requestHeaderGet())
        .then((response) => response.json())
        .then((data) => {
            setAllAparts(data);
            var filtered = data.find(x=>x.id === id);
            setApartment(filtered);
            console.log(filtered);
        })
        .catch((err) => {
           console.log(err.message);
        });
    }

    function goToAnchor(anchor){
        const posy = document.getElementById(anchor)?.getBoundingClientRect().top;
        document.getElementById(anchor)?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });   
        const yOffset = -70; 
        const y = posy + window.scrollY + yOffset;

        window.scrollTo({top: y, behavior: 'smooth'});
    }

    function CloseModal(){
        setModalOpened(false);
    }

    useEffect(() => {
        getData();
     }, []);
    useEffect(() => {        
        goToAnchor("main-page-content");
     }, [apartment]);

      useEffect(() => {
        const map = mapRef.current?.getMap();
        if (!map) return;

        const lat = parseFloat(apartment?.x);
        const lng = parseFloat(apartment?.y);

        if (!isFinite(lat) || !isFinite(lng)) {
        console.error('❌ Неверные координаты:', apartment);
        return;
        }

        const center = [lng, lat]; // [longitude, latitude]
        const circle = turf.circle(center, CIRCLE_RADIUS_METERS / 1000, {
        steps: 64,
        units: 'kilometers',
        });

        const sourceId = 'circle-source';
        const fillLayerId = 'circle-fill';
        const outlineLayerId = 'circle-outline';

        function addCircle() {
        if (!map.getSource(sourceId)) {
            map.addSource(sourceId, {
            type: 'geojson',
            data: circle,
            });

            map.addLayer({
            id: fillLayerId,
            type: 'fill',
            source: sourceId,
            paint: {
                'fill-color': '#007cbf',
                'fill-opacity': 0.3,
            },
            });

            map.addLayer({
            id: outlineLayerId,
            type: 'line',
            source: sourceId,
            paint: {
                'line-color': '#007cbf',
                'line-width': 2,
            },
            });
        }
        }

        if (map.isStyleLoaded()) {
        addCircle();
        } else {
        map.on('load', addCircle);
        }

        return () => {
        if (map.getLayer(fillLayerId)) map.removeLayer(fillLayerId);
        if (map.getLayer(outlineLayerId)) map.removeLayer(outlineLayerId);
        if (map.getSource(sourceId)) map.removeSource(sourceId);
        };
    }, [apartment]);

    function apartsList(){
        var sameProperty = allAparts.filter(x=>x.propertytype == apartment.propertytype);
        if(sameProperty == null || sameProperty.count == 0){
            sameProperty = allAparts.filter(x=>x.displayOnMain == true);
        }
        return sameProperty.map(x=>
            <div key={x.id}>
                <ApartCard data={x}/>
            </div>
        )
     }

     function shareLink(url){
        navigator.share({'url':url});
     }

     function setNextImage(currentImage){
        var index = apartment.images.findIndex(x=>x.link == currentImage);
        if(index == apartment.images.length-1){
            return apartment.images[0].link;
        }
        setenlargeimg(apartment.images[index+1].link);
     }

     function setPreviousImage(currentImage){
        var index = apartment.images.findIndex(x=>x.link == currentImage);
        if(index == 0){
            return apartment.images[apartment.images.length-1].link;
        }
        setenlargeimg(apartment.images[index-1].link);
     }

    const handlers = useSwipeable({
        onSwipedLeft: () => setNextImage(enlargeimg),
        onSwipedRight: () => setPreviousImage(enlargeimg),
        swipeDuration: 700,
        preventScrollOnSwipe: true,
        trackMouse: true
      });

     return (
        <>
            {modalOpened ? <ContactUs closeModal = {CloseModal}/> : ""}
            {enlargeimg != null && enlargeimg != ""
            ?
            <div {...handlers} className="enlarge-block">
                <div id='back' className='arrow' onClick={()=>setPreviousImage(enlargeimg)}>{"<"}</div>
                <div id='image'>
                    <img src={enlargeimg}/>
                </div>
                <div id='forward' onClick={()=>setNextImage(enlargeimg)} className='arrow'>{">"}</div>
                <div id='close' onClick={()=>setenlargeimg(null)}>X</div>
            </div>
            :
            ""
            }
            <Header/>        
            <div id="page">
                {!isMobile ?
                <div className="left-menu">
                    <LeftMenu/>
                </div>
                :""}
                <div id='main-page-content' className="main-page-content">     
                    <div className="apart-photos">
                        {apartment != null && apartment.images != null ? apartment.images.map(x=>
                            <>
                                <img onClick={()=>setenlargeimg(x.link)} src={x.link} />
                            </>                    
                            ) : ""} 
                    </div>
                    <br/>
                    <div id='details-page-top-buttons'>
                        <div className="white-button"
                        onClick={()=>
                                {
                                    shareLink(window.location);
                                }
                        }>{t('Partager')}<img id='share'
                            src='share.svg'
                            />
                        </div>
                        <div className="white-button"
                        onClick={()=>
                                {
                                    wishlistService.addToWishlistClick(apartid);
                                    setSateChange(!stateChange);
                                }
                        }>{t('Préféré')}<img id='like' className={wishlistService.isInWishlist(apartid) ? 'like-active' : ''}
                            src={wishlistService.isInWishlist(apartid) ? 'filled_heart.svg' : 'heart.svg'} 
                            />
                        </div>
                    </div>
                    {apartment != null ?
                    <div className="full-apart-description">
                        {selectvalues.AvailableStatus != apartment.status && "" !== apartment.status && !!apartment.status ?          
                        <>             
                        <div id='status' className={getStatusClass(apartment.status)}>
                            <label>{apartment.status}</label>   
                            {apartment.status == selectvalues.Reservedtatus ? <div>{"From " + apartment.reservedfrom + " To " + apartment.reservedto }</div>  :""}
                        </div>
                        </>
                        : ""}

                        <div id="title">
                            {apartment.name}
                        </div>
                        <br/>
                        <div id="location">
                            {apartment.neighborhood}
                        </div>

                        <BrowserView>
                        
                        <br/>
                        <table>
                            <thead>
                                <th>{t('Prix')}</th>
                                {apartment.propertytype == "Terrain"
                                ?
                                ""
                                :
                                <>                                 
                                    <th>{t('Chambres')}</th>
                                    <th>{t('Douches')}</th>
                                    <th>{t('Surface habitable')}</th>
                                </>
                                }
                                <th>{t('Superficie')}</th>
                            </thead>
                            <tbody>
                                <tr>
                                   <td>
                                        <div className={apartment.status == selectvalues.Promotiontatus ? "strikethrough-price" : ""}>
                                            {numberWithCommas(apartment.price)} FCFA {apartment.multiplepropertytype?.find(x=>x == "Terrain" ) != undefined ? 'par m²' :"" }   
                                        </div>    
                                        {apartment.status == selectvalues.Promotiontatus ?
                                            <div className="promotional-price">
                                                {numberWithCommas( apartment.promotionprice)} FCFA {apartment.multiplepropertytype?.find(x=>x == "Terrain" ) != undefined ? 'par m²' :"" }   
                                            </div>    
                                            :""     
                                        }                        
                                   </td> 
                                   
                                   {apartment.multiplepropertytype?.find(x=>x == "Terrain" ) == undefined && apartment.propertytype != "Terrain"
                                ?
                                <>   
                                    <td>{apartment.bedrooms}</td> 
                                    <td>{apartment.showers}</td> 
                                    <td>{apartment.livingarea} m²</td> 
                                </>
                                :
                                    ""
                                }
                                   <td>{apartment.landarea} m²</td> 
                                </tr>
                            </tbody>
                        </table>
                        </BrowserView>
                        <MobileView>
                        <table className="mobile-table">
                            <tbody>
                                <tr><th>{t('Prix')}</th> 
                                <td>
                                <div className={apartment.status == selectvalues.Promotiontatus ? "strikethrough-price" : ""}>
                                            {numberWithCommas(apartment.price)} FCFA {apartment.propertytype =='Terrain' ? 'par m²' :"" }   
                                        </div>    
                                        {apartment.status == selectvalues.Promotiontatus ?
                                            <div className="promotional-price">
                                                {numberWithCommas(apartment.promotionprice)} FCFA {apartment.propertytype =='Terrain' ? 'par m²' :"" }   
                                            </div>    
                                            :""     
                                        }  
                                </td> 
                                </tr>
                                {apartment.multiplepropertytype?.find(x=>x == "Terrain" ) == undefined && apartment.propertytype != "Terrain"
                                ?
                                    <>
                                    <tr><th>{t('Chambres')}</th><td>{apartment.bedrooms}</td> </tr>                                   
                                    <tr><th>{t('Douches')}</th><td>{apartment.showers}</td> </tr>
                                    <tr><th>{t('Surface habitable')}</th><td>{apartment.livingarea} m²</td> </tr>
                                    </>
                                :
                                ""
                                }
                                <tr><th>{t('Superficie')}</th><td>{apartment.landarea} m²</td></tr>
                            </tbody>
                        </table>
                        </MobileView>
                        
                        <div id="features">
                            {apartment.properties != null ? apartment.properties.map(x=>
                                <div>
                                    <div id="title">{x.name}</div>
                                    <div id="options">
                                        {x.options != null ? x.options.map(y=>
                                            <div>{y}</div>
                                            ) :""}
                                    </div>
                                </div>
                                
                                ) : ""}
                        </div>
                        {apartment.y != undefined?
                        <div id='map'>
                            <Map
                            ref={mapRef}
                            mapLib={maplibregl}
                            initialViewState={{
                                longitude: parseFloat(apartment.y),
                                latitude: parseFloat(apartment.x),
                                zoom: 16,
                            }}
                            style={{ width: '100%', height: '100%' }}
                            mapStyle={MAP_STYLE}
                            >
                            <NavigationControl position="top-right" />
                            </Map>

                        </div>
                        :""}
                        <div className="blue-button" onClick={()=> setModalOpened(true)}>Cet article m'interesse</div>
                    </div>                    
                 : ""}
                 
                    <div id="check-other">                                
                                {t('Consultez d’autres propositions')}
                            </div>
                            <div id="aparts-cards">                                
                                
                                {allAparts != null ? apartsList() : ""}
                    </div>
                 </div>
                  {/* <div className="main-page-content">    
                  <div id="not-found">{t('Content not found')}</div>
                  <div id="check-other">                                
                                 Consultez d’autres propositions'
                             </div>
                             <div id="aparts-cards">                                
                                
                                 { allAparts != null ? apartsList(allAparts.filter(x=>x.displayOnMain == true) ) : ""}
                    </div>
                  </div> */}
                 
            </div>
        </>
     )

}